import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Notificacao } from '../models/notificacao';
import { UsuarioProvider } from '../providers/usuario.provider';
import { BrowserBaseService } from './browser-base.service';

@Injectable({
  providedIn: 'root'
})
export class NotificacaoService extends BrowserBaseService {

  quantidadeNovas$: ReplaySubject<number>;

  _baseUrl = environment.urlBaseNotificacao;

  constructor(
    public router: Router,
    public http: HttpClient,
    public storage: Storage,
    public usuarioProvider: UsuarioProvider
  ) {
    super(router,
      http,
      storage,
      usuarioProvider);

    this.quantidadeNovas$ = new ReplaySubject<number>(1);
  }

  async litarPaginado(pageNumber: number, pageSize: number, textBusca?: string, visualizadas?: boolean, naoVisualizadas?: boolean, minhasNotificacoes?: boolean) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken
    };
    const filter: any = {
      siglaSistemaOrigem: 'CNES'
    }
    if (minhasNotificacoes) {
      filter.cpfOrigem = this.usuarioProvider.getUsuario().cpf;
    }
    if (textBusca && textBusca.trim()) {
      // filter.titulo = textBusca;
      // filter.textoResumido = textBusca;
      // filter.textoDetalhado = textBusca;
      filter.conteudoLivre = textBusca;
    }
    if (visualizadas !== undefined || naoVisualizadas !== undefined) {
      filter.visualizado = visualizadas ? visualizadas : (naoVisualizadas ? false : true);
    }
    return await this.http.post(environment.urlBaseNotificacao + '/notificacao/paginado',{filter, pageNumber, pageSize}, {headers}).toPromise();
  }

  async listarVisualizadas() {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken
    };
    return await this.http.get(environment.urlBaseNotificacao + '/notificacao/visualizada', {headers}).toPromise();
  }

  async listarNaoVisualizadas() {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken
    };
    return await this.http.get(environment.urlBaseNotificacao + '/notificacao/nao-visualizada', {headers}).toPromise();
  }

  async enviar(notificacao: Notificacao) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken
    };
    return await this.http.post(environment.urlBaseNotificacao + '/notificacao/', notificacao, {headers}).toPromise();
  }

  usarQuantidadeNovas(d: number) {
    this.quantidadeNovas$.next(d);
  }

  async novas(): Promise<void> {
    if (this.usuarioProvider.getUsuario()) {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken
      };
      // tslint:disable-next-line:max-line-length
      const mensagensNaoVisualizadas: number = await this.http.get<any>(environment.urlBaseNotificacao + '/notificacao/nao-lidas?sistema=CNES', {headers}).toPromise();
      this.usarQuantidadeNovas(mensagensNaoVisualizadas);
    }
  }

  async listarAbrangencias(siglaPerfil?: string) {
    let abrangencias: any = await this.http.get('./assets/dados-fake/abrangencias-notificacao.json').toPromise();
    if(siglaPerfil) {
      abrangencias = abrangencias.filter((a: any) => {
        return !!a.siglas.filter(s => s === siglaPerfil).length;
      });
    }
    return abrangencias;
  }

  async lerNotificacoes(ids: Array<number>) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken
    };
    let url = environment.urlBaseNotificacao + '/notificacao/visualizada';
    ids.forEach((i, index) => {
      url = url + (index === 0 ? '?ids=' : '&ids=') + i;
    })
    return await this.http.put(url, undefined, {headers}).toPromise();
  }

  async marcarNaoLidas(ids: Array<number>) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken
    };
    let url = environment.urlBaseNotificacao + '/notificacao/nao-visualizada';
    ids.forEach((i, index) => {
      url = url + (index === 0 ? '?ids=' : '&ids=') + i;
    })
    return await this.http.put(url, undefined, {headers}).toPromise();
  }

  async apagarNotificacoes(ids: Array<number>) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken
    };
    let url = environment.urlBaseNotificacao + '/notificacao/';
    ids.forEach((i, index) => {
      url = url + (index === 0 ? '?ids=' : '&ids=') + i;
    })
    return await this.http.delete(url, {headers}).toPromise();
  }

  async getTextoDetalhado(id: number) {
    const headers = {
      Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken
    };
    return await this.http.get(environment.urlBaseNotificacao + '/notificacao/' + id + '/texto-detalhado', {headers, responseType: 'text'}).toPromise();
  }

  async getTiposPerfil() {
    const url = `./assets/dados-fake/tipo-perfil-notificacao.json`;
    return this.http.get(url).toPromise();
  }
}
